import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { compose, ExpEditor, withSitecoreContext } from '@/js/HOC';

const HeaderLinkItem = ({ fields }) => {
  return <> {fields?.Title && <Text tag="h4" className="link-row__title" field={fields.Title} />}</>;
};

export default compose(withSitecoreContext(), ExpEditor)(HeaderLinkItem);
